export default "__VITE_ASSET__Cq6PrA4H__"